import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import attendanceService from "../services/Attendances.Service";
export const getList = createAsyncThunk("attendances/list", async ({data, type}, thunkAPI)=> {
  try{
    let listData = [];
    let pageData =  Object.assign({}, data)
    
    // if(pageData.page){
    //     pageData.page = pageData.page - 1  
    // }
    listData =  await attendanceService.getList(pageData);
    return listData;
  }catch(exception){
    if (!exception.response) {
      return exception
    }
    return thunkAPI.rejectWithValue(exception?.response?.data)
  }
})

const initialState = {
  list:[],
  errors:false,
  success:false,
  loading:false,
  message:"",
  gameImageList:[],
  dates:[],
  totalCount:0
    
}

const AttendanceSlice = createSlice({
  name : "attendance",
  initialState,
  reducers:{
    reset:(state,action) =>{
      if(Object.keys(action.payload) > 0){
        return {
          ...initialState,
          ...action.payload
        }
      }else{
        return  initialState
      }
      
    },
    resetApiStatus:(state) => {
      return {
          ...initialState,
          errors:false,
          success:false,
          loading:false,
          message:false
      }
  },
  checkGoods: ()=>{
      console.log("Goods Check")
    } 
  },
  extraReducers: {
    [getList.pending] : (state) => {
      state.loading = true
      state.errors = false
      state.list = [];
      state.totalCount = 0
    },
    [getList.fulfilled] : (state, action) => {
      state.loading = false;
      state.totalCount = action.payload.totalDocs
      state.list = action.payload.docs; 
      state.dates = action.payload.allDates
    },    
    [getList.rejected] : (state, action) => {
      state.loading = false;
      state.success = false
      state.message = action.payload.error.msg;
    }
  }

})
export const { reset, resetApiStatus } = AttendanceSlice.actions;
export default AttendanceSlice.reducer 